import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import type { DialogType } from '../../../@types';
import { QUERY_KEYS } from '../../../constants';
import useFilterForm from '../../../hooks/useFilterForm';
import type { AdditionalQueryParams } from '../../../hooks/usePagination';
import { goldGamesFreeSpinFiltersSchema } from '../../../schema/goldGamesFreeSpinsSchema';
import FilterDialogLayout from '../../layouts/FilterDialogLayout';
import CustomerSelect from '../../molecules/CustomerSelect';

const DEFAULT_FORM_DATA = { playerId: '', campaign: '' };
type Props = DialogType & { changeQuery: (query: AdditionalQueryParams) => void };

const FilterGoldGamesFreeSpins = ({ changeQuery, closeModal }: Props) => {
  const { control, handleResetFilter, handleSubmit } = useFilterForm<typeof DEFAULT_FORM_DATA>({
    defaultData: DEFAULT_FORM_DATA,
    changeQuery,
    prepareQueryParams: (query) => goldGamesFreeSpinFiltersSchema.parse(query),
  });
  return (
    <FilterDialogLayout label='free spins' onSave={handleSubmit} onClose={closeModal} onReset={handleResetFilter}>
      <CustomerSelect
        control={control}
        name='playerId'
        label='Player'
        multipleSelect={false}
        queryKey={[QUERY_KEYS.customers, 'gold-games-history-players']}
      />
      <Controller
        name='campaign'
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            value={field.value ?? ''}
            label='Campaign'
            slotProps={{ htmlInput: { maxLength: 120 } }}
          />
        )}
      />
    </FilterDialogLayout>
  );
};
export default FilterGoldGamesFreeSpins;
